import {useNavigate} from 'react-router';
import {Theme, useMediaQuery} from '@mui/material';
import NavBarDesktop from './NavBarDesktop';
import NavBarMobile from './NavBarMobile';
import {createNavBarMenu} from './createNavBarMenu';
import {createUserMenu} from './createUserMenu';
import {User} from '@cp/model';

export interface NavBarProps {
  user: User;
}

export default function NavBar({user}: NavBarProps) {
  const navigate = useNavigate();
  const navItems = createNavBarMenu(navigate);
  const userMenu = createUserMenu(navigate, user);
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  return isMobile ? (
    <NavBarMobile user={user} navItems={navItems} userMenu={userMenu} />
  ) : (
    <NavBarDesktop user={user} navItems={navItems} userMenu={userMenu} />
  );
}
